module.exports = __webpack_public_path__ + "static/media/hour-of-code-lesson-plan.71d62488.png";